import { SubTitle } from 'components/text/SubTitle';
import { Checkbox, Typography } from 'enable-ui';

import { COLOR, COLOR_CONFIG } from 'constants/color';

export const getExercisesInLessonColumn = (
  onChangeSelectedExercises: (value: string) => () => void,
  selectedExercises: Record<string, string>,
) => {
  return [
    {
      id: 'selected',
      width: 20,
      maxWidth: 20,
      minWidth: 20,
      Cell: ({ ...props }) => {
        return (
          <Checkbox
            checked={Boolean(selectedExercises[props.data[props.row.index]['id']])}
            onClick={onChangeSelectedExercises(props.data[props.row.index]['id'])}
          />
        );
      },
    },
    {
      id: 'name',
      width: '100%',
      minWidth: '100%',

      Cell: ({ ...props }) => {
        const typoStyle = {
          maxWidth: 386,
        };

        const name = props.data[props.row.index]?.name;

        const category = props.data[props.row.index]?.category.name;

        return (
          <div>
            <Typography
              className="ellipsis"
              style={typoStyle}
              weight={600}
              variant="body-2"
              color={COLOR.surfaceNeutralBold['neutral-11']}
            >
              {category}
            </Typography>

            <Typography
              style={typoStyle}
              className="mt-2 ellipsis"
              color={COLOR_CONFIG['neutral-text']}
              variant="body-3"
            >
              {name}
            </Typography>
          </div>
        );
      },
    },
  ];
};

export const getCourseLessonsColumn = (
  onChangeSelectedExercises: (value: string) => () => void,
  selectedExercises: Record<string, string>,
) => {
  return [
    {
      id: 'selected',
      Header: '',
      width: 20,
      maxWidth: 20,
      minWidth: 20,
      Cell: ({ ...props }) => {
        return (
          <Checkbox
            checked={Boolean(selectedExercises[props.data[props.row.index]['id']])}
            onClick={onChangeSelectedExercises(props.data[props.row.index]['id'])}
          />
        );
      },
    },
    {
      id: 'name',
      Header: 'Name',
      width: '100%',
      minWidth: '100%',
      Cell: ({ ...props }) => {
        const name = props.data[props.row.index]?.name;

        const totalExercises = props.data[props.row.index]?.totalExercises;

        return (
          <div>
            <Typography style={{ textAlign: 'start' }} weight={700}>
              {name}
            </Typography>
            <Typography style={{ textAlign: 'start' }} variant="h5">
              {totalExercises} exercises
            </Typography>
          </div>
        );
      },
    },
  ];
};

export const getLessonsInCourseColumn = (
  onChangeSelectedCourses: (value: string) => () => void,
  selectedCourses: Record<string, string>,
) => {
  return [
    {
      id: 'selected',
      width: 20,
      maxWidth: 20,
      minWidth: 20,
      Cell: ({ ...props }) => {
        return (
          <Checkbox
            checked={Boolean(selectedCourses[props.data[props.row.index]['id']])}
            onClick={onChangeSelectedCourses(props.data[props.row.index]['id'])}
          />
        );
      },
    },
    {
      id: 'name',
      width: '100%',
      minWidth: '100%',

      Cell: ({ ...props }) => {
        const name = props.data[props.row.index]?.name;

        const type = props.data[props.row.index]?.type?.name;

        const totalExercises = props.data[props.row.index]?.totalExercises;

        return (
          <div>
            <Typography
              style={{
                textAlign: 'start',
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                width: 200,
              }}
              variant="h5"
            >
              {name}
            </Typography>
            <SubTitle leftTitle={type ?? ''} rightTitle={`${totalExercises ?? 0} exercises`} />
          </div>
        );
      },
    },
  ];
};

export const getFunctionalTestInAssessmentColumn = (
  onChangeSelectedFunctionalTest: (value: string) => () => void,
  selectedFunctionalTest: Record<string, string>,
) => {
  return [
    {
      id: 'selected',
      width: 20,
      maxWidth: 20,
      minWidth: 20,
      Cell: ({ ...props }) => {
        return (
          <Checkbox
            checked={Boolean(selectedFunctionalTest[props.data[props.row.index]['id']])}
            onClick={onChangeSelectedFunctionalTest(props.data[props.row.index]['id'])}
          />
        );
      },
    },
    {
      id: 'name',
      width: '100%',
      minWidth: '100%',

      Cell: ({ ...props }) => {
        const name = props.data[props.row.index]?.name;

        const type = props.data[props.row.index]?.type?.name;

        return (
          <div>
            <Typography
              style={{
                textAlign: 'start',
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                width: 200,
              }}
              variant="h5"
            >
              {name}
            </Typography>
            <Typography style={{ textAlign: 'start' }} variant="h5">
              {type}
            </Typography>
          </div>
        );
      },
    },
  ];
};

export const getAssessmentsInCourseColumn = (
  onChangeSelectedAssessments: (value: string) => () => void,
  selectedAssessments: Record<string, string>,
) => {
  return [
    {
      id: 'selected',
      width: 20,
      maxWidth: 20,
      minWidth: 20,
      Cell: ({ ...props }) => {
        return (
          <Checkbox
            checked={Boolean(selectedAssessments[props.data[props.row.index]['id']])}
            onClick={onChangeSelectedAssessments(props.data[props.row.index]['id'])}
          />
        );
      },
    },
    {
      id: 'name',
      width: '100%',
      minWidth: '100%',

      Cell: ({ ...props }) => {
        const name = props.data[props.row.index]?.name;

        const totalFunctionalTest = props.data[props.row.index]?.totalFunctionalTests;

        return (
          <div>
            <Typography
              style={{
                textAlign: 'start',
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                width: 200,
              }}
              variant="h5"
            >
              {name}
            </Typography>
            <Typography>{totalFunctionalTest} tests</Typography>
          </div>
        );
      },
    },
  ];
};
